import * as React from "react";

const SvgArrow = (props) => (
  <svg
    viewBox="0 0 37.775 32.2"
    width="1em"
    height="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="m22.8 32.2 14-13.8c1.3-1.3 1.3-3.3 0-4.6L22.8 0l-4.7 4.6 8.4 8.2H0v6.5h26.6l-8.4 8.2z" />
  </svg>
);

export default SvgArrow;